export default __webpack_public_path__ + "static/media/Luctus.6a710545.jpg";